<template>
  <section class="profile-view">
    <div
      class="vue-form"
      v-loading="loadingProfile"
      element-loading-text="Fetching Profile..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <el-form ref="form" v-model="formData">
        <el-row :gutter="20">
          <el-col :xl="8" :lg="8" :md="8" :sm="12" :xs="24">
            <div class="form-group">
              <label for="text">
                First Name
                <span class="star">*</span>
              </label>
              <el-form-item>
                <el-input
                  type="text"
                  v-model="formData.first_name"
                  placeholder="Enter First Name"
                ></el-input>
                <span class="error" v-if="getErrors && getErrors.first_name">{{
                  this.getErrors.first_name
                }}</span>
              </el-form-item>
            </div>
          </el-col>
          <el-col :xl="8" :lg="8" :md="8" :sm="12" :xs="24">
            <div class="form-group">
              <label for="text">
                Last Name
                <span class="star">*</span>
              </label>
              <el-form-item>
                <el-input
                  type="text"
                  v-model="formData.last_name"
                  placeholder="Enter Last Name"
                ></el-input>
                <span class="error" v-if="getErrors && getErrors.last_name">{{
                  this.getErrors.last_name
                }}</span>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :xl="8" :lg="8" :md="8" :sm="12" :xs="24">
            <div class="form-group">
              <label for="text">
                Educational Qualification
                <span class="star">*</span>
              </label>
              <el-form-item>
                <el-input
                  placeholder="Select Educational Qualification"
                  v-model="formData.educational_qualification"
                >
                </el-input>
                <span
                  class="error"
                  v-if="getErrors && getErrors.educational_qualification"
                  >{{ this.getErrors.educational_qualification }}</span
                >
              </el-form-item>
            </div>
          </el-col>
          <el-col :xl="6" :lg="6" :md="8" :sm="12" :xs="24">
            <div class="form-group">
              <label for="text">
                Date of Birth
                <span class="star">*</span>
              </label>
              <el-form-item>
                <el-date-picker
                  v-model="formData.dob"
                  type="date"
                  value-format="yyyy-MM-dd"
                  format="MM-dd-yyyy"
                  placeholder="Date of Birth"
                  :picker-options="defaultDateOptions"
                  :editable="false"
                ></el-date-picker>

                <span class="error" v-if="getErrors && getErrors.dob">{{
                  this.getErrors.dob
                }}</span>
              </el-form-item>
            </div>
          </el-col>
          <el-col :xl="5" :lg="5" :md="8" :sm="12" :xs="24">
            <div class="form-group">
              <label for="text">
                Gender
                <span class="star">*</span>
              </label>
              <el-form-item>
                <el-select
                  placeholder="Select Gender"
                  v-model="formData.gender"
                  filterable
                  default-first-option
                  clearable
                >
                  <el-option label="Male" value="MALE"></el-option>
                  <el-option label="Female" value="FEMALE"></el-option>
                </el-select>
                <span class="error" v-if="getErrors && getErrors.gender">{{
                  this.getErrors.gender
                }}</span>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :xl="6" :lg="6" :md="8" :sm="12" :xs="24">
            <div class="form-group">
              <label for="text">
                Phone Number
                <span class="star">*</span>
              </label>
              <el-form-item>
                <el-input
                  type="text"
                  v-model="formData.phone"
                  placeholder="Enter Phone Number"
                  maxlength="10"
                ></el-input>
                <span class="error" v-if="getErrors && getErrors.phonr">{{
                  this.getErrors.phone
                }}</span>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="form-group">
              <label for="text"> Fax No </label>
              <el-form-item>
                <el-input
                  type="text"
                  v-model="formData.fax"
                  placeholder="Enter Fax No"
                ></el-input>
                <span class="error" v-if="getErrors && getErrors.fax">{{
                  this.getErrors.fax
                }}</span>
              </el-form-item>
            </div>
          </el-col>
          <el-col :xl="6" :lg="6" :md="8" :sm="12" :xs="24">
            <div class="form-group">
              <label for="text">
                Email Address
                <span class="star">*</span>
              </label>
              <el-form-item>
                <el-input
                  type="email"
                  class="email-lower"
                  v-model="formData.email"
                  placeholder="Enter Email"
                ></el-input>
                <span class="error" v-if="getErrors && getErrors.email">{{
                  this.getErrors.email
                }}</span>
              </el-form-item>
            </div>
          </el-col>
          <el-col
            :xl="6"
            :lg="6"
            :md="8"
            :sm="12"
            :xs="24"
            v-if="formData.user_type == 'LAB_MANAGER'"
          >
            <div class="form-group">
              <label for="text">
                Report Signature sdfgh
                <span class="star">*</span>
              </label>
              <el-form-item>
                <el-input
                  type="text"
                  v-model="formData.report_signature"
                  placeholder="Enter Report Signature"
                ></el-input>
                <span
                  class="error"
                  v-if="getErrors && getErrors.report_signature"
                  >{{ this.getErrors.report_signature }}</span
                >
              </el-form-item>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :xl="8" :lg="8" :md="8" :sm="12" :xs="24">
            <div class="form-group">
              <label for="text">
                Address Line 1
                <span class="star">*</span>
              </label>
              <el-form-item>
                <el-input
                  type="textarea"
                  :rows="3"
                  v-model="formData.address.line_one"
                  placeholder="Enter Address Line 1"
                ></el-input>
                <span
                  class="error"
                  v-if="getErrors && getErrors['address.line_one']"
                  >{{ this.getErrors["address.line_one"] }}</span
                >
              </el-form-item>
            </div>
          </el-col>
          <el-col :xl="8" :lg="8" :md="8" :sm="12" :xs="24">
            <div class="form-group">
              <label for="text">
                Address Line 2
                <span class="star">*</span>
              </label>
              <el-form-item>
                <el-input
                  type="textarea"
                  :rows="3"
                  v-model="formData.address.line_two"
                  placeholder="Enter Address Line 2"
                ></el-input>
                <span
                  class="error"
                  v-if="getErrors && getErrors['address.line_two']"
                  >{{ this.getErrors["address.line_two"] }}</span
                >
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :xl="6" :lg="6" :md="8" :sm="12" :xs="24">
            <state :stateData="formData"></state>
          </el-col>
          <el-col :xl="6" :lg="6" :md="8" :sm="12" :xs="24">
            <city :cityData="formData"></city>
          </el-col>

          <el-col :xl="6" :lg="6" :md="8" :sm="12" :xs="24">
            <div class="form-group">
              <label for="text">
                Zip
                <span class="star">*</span>
              </label>
              <el-form-item>
                <el-input
                  placeholder="Enter Zip"
                  v-model="formData.address.zip"
                >
                </el-input>
                <span
                  class="error"
                  v-if="getErrors && getErrors['address.zip']"
                  >{{ this.getErrors["address.zip"] }}</span
                >
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <div class="submit-btn-group">
          <el-row>
            <el-col :span="24">
              <ul>
                <li>
                  <button
                    type="button"
                    class="btn cancel-btn el-shadow all-btn"
                    @click="cacelUpdate"
                  >
                    Cancel
                  </button>
                </li>
                <li>
                  <button
                    type="button"
                    class="btn update-btn all-btn"
                    v-loading="loading"
                    :disabled="loading"
                    @click="updateProfile"
                  >
                    Save
                  </button>
                </li>
              </ul>
            </el-col>
          </el-row>
          <span class="error" v-if="getErrors && getErrors.error">{{
            this.getErrors.error
          }}</span>
        </div>
      </el-form>
    </div>
    <div class="vue-form-data">
    </div>
  </section>
</template>

<script>
import { defineAsyncComponent } from "vue";
import { mapGetters } from "vuex";
const state = defineAsyncComponent(() => import("@/components/misc/State"));
const city = defineAsyncComponent(() => import("@/components/misc/City"));
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  name: "profile",
  components: {
    state,
    city,
  },
  computed: {
    ...mapGetters("profile", [
      "getProfileData",
      "getProfileUpdateStatus",
      "getStatesData",
    ]),
    ...mapGetters("errors", ["getErrors"]),
  },

  data() {
    return {
      loading: false,
      loadingProfile: false,
      states: {},
      formData: {
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        educational_qualification: "",
        username: "",
        dob: "",
        gender: "",
        address: {
          line_one: "",
          line_two: "",
          city: "",
          state: "",
          zip: "",
        },
        user_type: "",
      },
      defaultDateOptions: {
        disabledDate(date) {
          const disableNewDates = date.setDate(date.getDate());
          return disableNewDates > new Date();
        },
      },
    };
  },
  async mounted() {
    this.loadingProfile = true;
    await this.$store.dispatch("profile/getStates");
    if (this.getStatesData) {
      this.states = this.getStatesData;
    }
    await this.$store.dispatch("profile/getProfile");
    if (this.getProfileData) {
      this.formData = { ...this.formData, ...this.getProfileData };
    }
    this.loadingProfile = false;
  },
  methods: {
    async updateProfile() {
      let params = this.formData;
      if (params.email) {
        params.email = params.email.toLowerCase();
      }
      this.loading = true;
      await this.$store.dispatch("profile/updateProfile", params);
      this.loading = false;
      if (this.getProfileUpdateStatus && this.getProfileUpdateStatus.success) {
        successNotification(this.getProfileUpdateStatus.message);
        this.$router.push({ name: "user-profile" });
      }
    },
    async cacelUpdate() {
      this.formdata = { ...this.formData, ...this.getProfileData };
      await this.$router.push({ name: "profile-view" });
    },
  },
};
</script>

<style lang="scss" scoped>
.profile-view {
  .vue-form {
    .form-group {
      margin-bottom: 30px;
    }
    .submit-btn-group {
      border-top: 1px solid #d5dae2;
      padding: 15px 0 15px 0;
      ul {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        li {
          &:not(:last-child) {
            margin-right: 1em;
          }
          .cancel-btn {
            background: #ffffff;
            border: 1px solid #cdd2fd;
            border-radius: 5px;
            font-weight: 600;
            color: #151522;
          }
          .update-btn {
            box-shadow: 0px 4px 8px rgba(50, 50, 71, 0.06),
              0px 4px 4px rgba(50, 50, 71, 0.08);
            background: #6f52ed;
            border-radius: 5px;
            color: #fff;
            font-weight: 600;
          }
        }
      }
    }
  }
}
</style>
